import { ReactNode } from 'react'
import cn from 'classnames'

import './styles.scss'

export interface TooltipProps {
  content: ReactNode
  rounded?: boolean
  centered?: boolean
  width?: number | string
  left?: number | string
  right?: number | string
  top?: number | string
  bottom?: number | string
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
  className?: string
  onClose?: () => void
}

export const Tooltip = (props: TooltipProps) => {
  const {
    content,
    width,
    left,
    right,
    top,
    bottom,
    rounded,
    centered,
    onClose,
    position = 'top-right',
    className,
  } = props

  return (
    <div
      className={cn('base-tooltip', className, position, {
        rounded,
        centered,
        closable: onClose,
      })}
      style={{ width, maxWidth: width, left, right, top, bottom }}
    >
      {onClose && (
        <button className="close-tooltip" onClick={onClose}>
          &times;
        </button>
      )}
      <div className="tooltip-content">{content}</div>
    </div>
  )
}
